<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { dataSelectionSearch } from '$lib/stores/dataSelectionSearch';

  let searchQuery = '';

  // Publish this component's query for the list beside it.
  $: dataSelectionSearch.set(searchQuery);
</script>

<!--
  The field is white and stays white. It was `bg-gray-50` with a `focus:bg-white`
  that lifted it on focus — a device for a field sitting on white, where grey is
  the only way to show an edge. This panel sits on the rail, where grey is the
  *ground*: the field was a shade lighter than what it stood on and the focus
  jump went the wrong way. White is what every other input in the app uses, and
  on the rail it reads as raised without needing a state change to do it.
-->
<div class="w-full">
  <!-- Search Section -->
  <div class="relative">
    <input
      class="w-full rounded-control border border-hairline bg-surface-panel px-4 py-3 pr-10 text-sm placeholder-gray-400 transition-colors focus:border-accent-400 focus:outline-none focus:ring-2 focus:ring-accent-100"
      type="text"
      placeholder={$_('form.placeholders.searchByName')}
      bind:value={searchQuery}
    />
    <div class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 transform">
      <svg class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
  </div>

  {#if searchQuery.trim()}
    <div class="mt-2 text-xs text-gray-500">
      Showing filtered results for "{searchQuery}"
    </div>
  {/if}
</div>
